import {useCallback} from 'react'
import dayjs from 'dayjs'
import {useGetHolidays} from '@/features/projects/queries/useGetHolidays'

/**
 * Custom hook for date validation utilities
 * @returns Functions to check dates (holidays, disabled days)
 */
export const useDateValidation = () => {
    // Get the current year for holidays
    const currentYear = dayjs().year()

    // Fetch holidays for current year
    const {data: holidays = []} = useGetHolidays({
        urlParams: {year: currentYear}
    })

    // Check if a date is a holiday
    const isHoliday = useCallback(
        (date: Date) => {
            const formattedDate = dayjs(date).format('YYYY-MM-DD')
            return holidays.some(holiday => holiday.date === formattedDate)
        },
        [holidays]
    )

    // Check if a date should be disabled (Sunday or holiday)
    const isDisabledDay = useCallback(
        (date: Date | string) => {
            const dateObj = typeof date === 'string' ? new Date(date) : date
            return dateObj.getDay() === 0 || isHoliday(dateObj)
        },
        [isHoliday]
    )

    return {
        isHoliday,
        isDisabledDay
    }
}
